import React from 'react';
import {IconButton, Tooltip} from '@chakra-ui/react';
import {CloseIcon} from '@chakra-ui/icons';
import {useTranslation} from 'react-i18next';

interface ResetPriceButtonProps {
  onReset: () => void;
  isLoading?: boolean;
}

/**
 * Bouton de réinitialisation du prix
 * pour réinitialiser le prix au tarif catalogue (`prix_dero_souhaite: null`).
 * Apparaît au hover quand un prix a été modifié
 */
export const ResetPriceButton: React.FC<ResetPriceButtonProps> = ({
  onReset,
  isLoading = false,
}) => {
  const {t} = useTranslation();

  return (
    <Tooltip
      label={t('back_office.prise_de_commande.panier.reinitialiser_prix')}
      placement='top'
    >
      <IconButton
        icon={<CloseIcon boxSize={2.5} />}
        aria-label={t(
          'back_office.prise_de_commande.panier.reinitialiser_prix',
        )}
        size='xs'
        variant='ghost'
        color='gray.dark'
        _hover={{fontWeight: '700'}}
        onClick={(e) => {
          e.stopPropagation();
          onReset();
        }}
        isLoading={isLoading}
        minW='20px'
        h='20px'
      />
    </Tooltip>
  );
};
